<div class="page-container">
  <app-back-link link="/settings" label="Back to Settings"></app-back-link>
  <app-page-header
    title="MCP System Prompt Builder"
    description="Generated system prompt for external LLMs using USER_PROFILE, KNOWN_WATERS, RULES, and concise MCP tool guidance.">
  </app-page-header>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>

  <div class="error-panel" *ngIf="error">{{ error }}</div>

  <div class="actions-row" *ngIf="content">
    <button mat-stroked-button color="primary" (click)="copyPrompt()">Copy Prompt</button>
    <span class="copy-message" *ngIf="copyMessage">{{ copyMessage }}</span>
  </div>

  <div class="guide-content" *ngIf="content" [innerHTML]="content | markdown"></div>
</div>
